import { loadRuntimeConfig } from './RuntimeConfig';

loadRuntimeConfig()
  .then(() => import('./bootstrap'))
  .catch(() => {
    const root = document.getElementById('root');
    if (root) {
      root.setAttribute('role', 'alert');
      root.textContent = 'Signaturely could not start. Please reload the page.';
    }
  });
